import { render, staticRenderFns } from "./qs1-06.vue?vue&type=template&id=6b2a53aa&scoped=true&"
import script from "./qs1-06.vue?vue&type=script&lang=js&"
export * from "./qs1-06.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2a53aa",
  null
  
)

export default component.exports